import DapDSRadioButton from './radio-button.component'

export * from './radio-button.component'
export default DapDSRadioButton

DapDSRadioButton.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-radio-button': DapDSRadioButton
  }
}
